import { IFieldsService } from "../../../types"
import { PlanContext } from "../../context"
import { useInitialScrollPosition } from "./hooks"

import { fields } from "../../../omnia"

const tl = fields.timeline

interface Props {
    selectedFieldId?: number
}


export function Timeline({ selectedFieldId }: Props) {

    const { fieldSvc } = React.useContext(PlanContext)

    const timelineRef = React.useRef<HTMLDivElement>()

    const props = React.useMemo(() => getTimelineProps(fieldSvc, selectedFieldId), [fieldSvc, selectedFieldId])

    useInitialScrollPosition(timelineRef, props?.vm)

    if (!props) {
        return null
    }

    const { vm, viewState } = props
    const { fields } = vm
    const field = fields[0]

    return <div className="timeline">

        <div className="omnia-fields-timeline react" ref={timelineRef}>

            <tl.Dates {... { vm, viewState, setWidth: true }} />

            <div className="tl-fields tl-crops">

                <tl.SingleField {...{ field, vm, fieldWidth: 0, onPointerDown: () => { }, verticalOffset: 0 }} />

            </div>

        </div>

    </div>

}


function getTimelineProps(svc: IFieldsService, selectedFieldId: number) {

    if (!selectedFieldId) {
        return
    }

    const field = svc.findField(selectedFieldId)

    if (!field) {
        return
    }

    const years = tl.setupYears(svc)

    const viewConfig = tl.getDefaultViewConfig({
        durationScale: 1.5,
        fieldHeight: 0,
        croppingHeight: 45
    })

    const { vm, viewState } = tl.getInitialState(
        undefined,
        [field],
        svc.cropYear,
        years.range,
        viewConfig,
        false
    )

    return {
        vm,
        viewState
    }

}

